import { useMutation } from '@tanstack/react-query';
import { useAuthStoreV1 } from '@/stores/authStore_v1';
import { startMcpOAuth } from '@/services/mcp-gateway';
import type { StartMcpOAuthInput } from '@/services/mcp-gateway';

export function useStartMcpOAuth() {
  const orgId = useAuthStoreV1((s) => s.selectedOrg?.id ?? null);

  return useMutation({
    mutationFn: (input: StartMcpOAuthInput) => startMcpOAuth(input, orgId),
    onSuccess: (authorizeUrl) => {
      window.location.assign(authorizeUrl);
    },
  });
}
